import { emailRegex } from "./common";

export const validateProjectDetails = (
  projectDetails,
  projectDetailsErrText,
  setProjectDetailsErrText
) => {
  let isValid = true;

  // Define initial errors state
  const errors = {
    project_title: "",
    type: "",
    completion_year: "",
    tenure: "",
    units: "",
    address: "",
    country: "",
    city: "",
    postal_code: "",
    full_name: "",
    email_address: "",
    position: "",
    contact_number: "",
    country_code: "",
  };

  const validateField = (field, message) => {
    if (!projectDetails[field]?.trim()) {
      errors[field] = message;
      isValid = false;
    }
  };
  const validateOtherField = (field, message) => {
    if (projectDetails[field] === null || projectDetails[field] === "") {
      errors[field] = message;
      isValid = false;
    }
  };

  const validateNumber = (field, message) => {
    if (!projectDetails[field]) {
      errors[field] = message;
      isValid = false;
    } else if (isNaN(projectDetails[field]) || projectDetails[field] <= 0) {
      errors[field] = "Must be a positive number.";
      isValid = false;
    }
  };

  const validateEmail = (email, field) => {
    if (!email.trim()) {
      errors[field] = "Email address is required.";
      isValid = false;
    } else if (!emailRegex.test(email)) {
      errors[field] = "Enter a valid email address.";
      isValid = false;
    }
  };

  const validatePostalCode = (code, field) => {
    if (!code.trim()) {
      errors[field] = "Postal code is required.";
      isValid = false;
    } else if (!/^\d{5,6}$/.test(code)) {
      errors[field] = "Postal code must be 5-6 digits.";
      isValid = false;
    }
  };

  const validatePhone = (phone, field) => {
    if (!phone.trim()) {
      errors[field] = "Contact number is required.";
      isValid = false;
    } else if (!/^\d{6,}$/.test(phone)) {
      errors[field] = "Contact number must be at least 6 digits.";
      isValid = false;
    }
  };
  if (projectDetails.country && projectDetails.country.length < 3) {
    errors.country = "Country name must be at least 3 characters long";
    isValid = false;
  }
  if (projectDetails.address && projectDetails.address.length < 3) {
    errors.address = "Address must be at least 3 characters long";
    isValid = false;
  }
  // Field validations
  validateField("project_title", "Project title is required.");
  validateOtherField("type", "Project type is required.");
  validateField("completion_year", "Completion year is required.");
  if (
    projectDetails.completion_year &&
    (!/^\d{4}$/.test(projectDetails.completion_year) ||
      projectDetails.completion_year < 1901 ||
      projectDetails.completion_year > 2155)
  ) {
    errors.completion_year =
      "Completion year must be a valid year between 1901 and 2155.";
    isValid = false;
  }

  validateNumber("tenure", "Tenure is required.");
  validateNumber("units", "Units are required.");
  validateField("address", "Address is required.");
  validateField("country", "Country is required.");
  validateField("city", "City is required.");
  validatePostalCode(projectDetails.postal_code, "postal_code");
  validateField("full_name", "Full name is required.");
  validateEmail(projectDetails.email_address, "email_address");
  validateField("position", "Position is required.");
  validatePhone(projectDetails.contact_number, "contact_number");
  validateField("country_code", "Country code is required.");
  if (
    projectDetails?.project_title.trim() !== "" &&
    projectDetailsErrText?.project_title
  ) {
    errors.project_title = "Project Title is already existed";
    isValid = false;
  }
  if (projectDetails.city && projectDetails.city.length < 3) {
    errors.city = "City must be at least 3 characters long";
    isValid = false;
  }
  // Update state with errors
  setProjectDetailsErrText(errors);

  return isValid;
};

export const validateCompanyDetails = (
  companyDetails,
  PDF,
  companyDetailsErrText,
  setCompanyDetailsErrText,
  trialDisable
) => {
  let isValid = true;

  // Define initial errors state
  const errors = {
    company_category: "",
    company_name: "",
    company_country: "",
    company_email_address: "",
    company_contact_number: "",
    company_address: "",
    company_country_code: "",
    billing_entity: "",
    billing_full_name: "",
    billing_email_address: "",
    billing_cycle: "",
    billing_contact_number: "",
    billing_contract_terms: "",
    billing_country_code: "",
    billing_commence_date: "",
    billing_end_date: "",
    contract: "",
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateField = (field, message) => {
    if (!companyDetails[field]?.trim()) {
      errors[field] = message;
      isValid = false;
    }
  };
  const validateOtherField = (field, message) => {
    if (companyDetails[field] === null || companyDetails[field] === "") {
      errors[field] = message;
      isValid = false;
    }
  };

  const validateEmail = (email, field) => {
    if (!email.trim()) {
      errors[field] = "Email address is required";
      isValid = false;
    } else if (!emailRegex.test(email)) {
      errors[field] = "Enter a valid email address";
      isValid = false;
    }
  };

  const validatePhone = (phone, field) => {
    if (!phone.trim()) {
      errors[field] = "Contact number is required";
      isValid = false;
    }
  };

  validateField("company_name", "Company name is required");
  validateField("company_country", "Country is required");
  validateEmail(companyDetails.company_email_address, "company_email_address");
  validatePhone(
    companyDetails.company_contact_number,
    "company_contact_number"
  );

  if (
    companyDetails.company_contact_number.slice(
      companyDetails.company_country_code.length
    ).length < 6
  ) {
    errors.company_contact_number =
      "Contact number must be at least 6 characters long (excluding dial code)";
    isValid = false;
  }
  if (
    companyDetails.company_country &&
    companyDetails.company_country.length < 3
  ) {
    errors.company_country = "Country name must be at least 3 characters long";
    isValid = false;
  }

  if (
    companyDetails.company_address &&
    companyDetails.company_address.length < 3
  ) {
    errors.company_address = "Address must be at least 3 characters long";
    isValid = false;
  }

  if (
    companyDetails.billing_contact_number.slice(
      companyDetails.billing_country_code.length
    ).length < 6
  ) {
    errors.billing_contact_number =
      "Contact number must be at least 6 characters long (excluding dial code)";
    isValid = false;
  }
  if (
    companyDetails.company_address.length < 3 ||
    companyDetails.company_address.length > 1000
  ) {
    errors.company_address = "Address must be between 3 and 1000 characters";
    isValid = false;
  }
  if (
    companyDetails.company_country.length < 3 ||
    companyDetails.company_country.length > 20
  ) {
    errors.company_country = "Country must be between 3 and 20 characters";
    isValid = false;
  }

  validateField("company_address", "Address is required");

  validateField("billing_entity", "Billing entity is required");
  validateField("billing_full_name", "Billing full name is required");

  validateEmail(companyDetails.billing_email_address, "billing_email_address");
  validatePhone(
    companyDetails.billing_contact_number,
    "billing_contact_number"
  );
  validateOtherField("billing_cycle", "Billing cycle is required");
  validateField(
    "billing_contract_terms",
    "Billing contract terms are required"
  );

  validateOtherField("billing_commence_date", "Commence date is required");
  validateOtherField("billing_end_date", "End date is required");

  const commenceDate = new Date(companyDetails.billing_commence_date);
  const endDate = new Date(companyDetails.billing_end_date);

  if (
    companyDetails.billing_commence_date &&
    companyDetails.billing_end_date &&
    endDate <= commenceDate
  ) {
    errors.billing_end_date = "End date must be greater than commence date";
    isValid = false;
  }

  if (
    companyDetails.billing_commence_date &&
    companyDetails.billing_end_date &&
    commenceDate >= endDate
  ) {
    errors.billing_commence_date =
      "Commence date must be earlier than end date";
    isValid = false;
  }
  if (!trialDisable) {
    if (!companyDetails.contract && PDF?.path === "") {
      errors.contract = "Contract file is required";
      isValid = false;
    } else if (!PDF?.path === "") {
      if (
        ![".pdf", ".doc", ".docx", ".csv", ".xlsx"].some((ext) =>
          companyDetails?.contract?.name.endsWith(ext)
        )
      ) {
        errors.contract =
          "Invalid file type. Only PDF, DOC, DOCX, CSV, or XLSX files are allowed.";
        isValid = false;
      } else if (companyDetails?.contract?.size > 5000000) {
        errors.contract = "File size exceeds 5MB limit.";
        isValid = false;
      }
    }
    if (PDF?.path === "") {
      validateOtherField("contract", "Contract is required");
    }
  }
  if (
    companyDetails?.company_name?.trim() !== "" &&
    companyDetailsErrText?.company_name
  ) {
    errors.company_name = "Company name is already existed";
    isValid = false;
  }
  // Update state with errors
  setCompanyDetailsErrText(errors);

  return isValid;
};

export const validateAdministratorDetails = (
  administratorDetails,
  administratorErrText,
  setAdministratorErrText
) => {
  let isValid = true;

  const errors = {
    full_name: "",
    email_address: "",
  };
  if (!administratorDetails?.full_name.trim()) {
    errors.full_name = "Company name is required";
    isValid = false;
  }

  if (!administratorDetails?.email_address.trim()) {
    errors.email_address = "Email address is required";
    isValid = false;
  } else if (!emailRegex.test(administratorDetails?.email_address)) {
    errors.email_address = "Please enter a valid email address";
    isValid = false;
  }
  if (
    !administratorDetails?.full_name.trim() !== "" &&
    administratorErrText?.full_name
  ) {
    errors.full_name = "Name is already existed";
    isValid = false;
  }
  if (
    administratorDetails?.email_address.trim() !== "" &&
    administratorErrText?.email_address
  ) {
    errors.email_address = "Name is already existed";
    isValid = false;
  }
  setAdministratorErrText(errors);
  return isValid;
};
